/* Pulsación larga con el dedo (o botón derecho del ratón) sobre la tarjeta de un canal: abre su menú (favorito, mover en la hilera…).
   Con el mando de la tele lo hace la propia navegación por foco (OK mantenido, ver core/tvnav.js). Tras la pulsación larga se anula el
   toque que viene detrás (si no, además de abrir el menú se reproduciría el canal). */

const HOLD_MS = 550;
const MOVE_TOLERANCE = 10;

export function bindCardLongPress({ selector = '.card-channel', onLongPress }) {
    let timer = null;
    let start = null;
    let firedAt = 0;
    const cancel = () => { clearTimeout(timer); timer = null; start = null; };
    const fire = (card) => {
        firedAt = Date.now();
        try { if (navigator.vibrate) navigator.vibrate(15); } catch (e) { /* sin vibración */ }
        onLongPress(card);
    };
    document.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return; // el botón derecho va por «contextmenu»
        const card = e.target.closest && e.target.closest(selector);
        if (!card) return;
        cancel();
        start = { x: e.clientX, y: e.clientY };
        timer = setTimeout(() => { timer = null; fire(card); }, HOLD_MS);
    }, true);
    document.addEventListener('pointermove', (e) => {
        if (start && Math.hypot(e.clientX - start.x, e.clientY - start.y) > MOVE_TOLERANCE) cancel();
    }, true);
    ['pointerup', 'pointercancel', 'scroll'].forEach((ev) => document.addEventListener(ev, cancel, true));
    // El clic que sigue a una pulsación larga no debe abrir el canal.
    document.addEventListener('click', (e) => {
        if (Date.now() - firedAt < 700 && e.target.closest && e.target.closest(selector)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // Botón derecho (escritorio) y menú contextual del sistema (algunos Android): el mismo menú, sin repetir si ya salió por pulsación larga.
    document.addEventListener('contextmenu', (e) => {
        const card = e.target.closest && e.target.closest(selector);
        if (!card) return;
        e.preventDefault();
        if (Date.now() - firedAt > 700) fire(card);
    }, true);
}
